module.exports = __webpack_public_path__ + "99d6d4d513ecfc61aca358ab6e898ccd.svg";